import React, { useState, useEffect, useMemo } from "react"; // 1. Importe o useMemo
import { Helmet } from "react-helmet-async";
import { CloudinaryImage } from "@cloudinary/url-gen";
import { AdvancedImage, responsive } from "@cloudinary/react";
import { scale } from "@cloudinary/url-gen/actions/resize";

export default function PreloadedCloudImage({ publicId, alt }) {
  const [preloadLink, setPreloadLink] = useState(null);
  const cloudName = "dqtcm6eo9";

  // 2. Use o useMemo para criar o objeto 'img' apenas quando o publicId mudar
  const img = useMemo(() => {
    return new CloudinaryImage(publicId, { cloudName: cloudName })
      .format("auto")
      .quality("auto");
  }, [publicId]); // A dependência agora é o publicId

  useEffect(() => {
    const widths = [100, 200, 300, 400];
    const sizesString = "(max-width: 600px) 90px, 120px";

    const srcSetString = widths
      .map((width) => {
        const url = new CloudinaryImage(publicId, { cloudName: cloudName })
          .format("auto")
          .quality("auto")
          .resize(scale().width(width))
          .toURL();
        return `${url} ${width}w`;
      })
      .join(", ");

    setPreloadLink(
      <Helmet>
        <link
          rel="preload"
          as="image"
          href={img.resize(scale().width(400)).toURL()}
          imagesrcset={srcSetString}
          imagesizes={sizesString}
          fetchpriority="high"
        />
      </Helmet>,
    );
  }, [img, publicId]); // A dependência 'img' aqui agora é segura porque é memorizada

  return (
    <>
      {preloadLink}
      <AdvancedImage
        cldImg={img}
        alt={alt}
        plugins={[responsive({ steps: 100 })]}
        fetchpriority="high"
      />
    </>
  );
}
